import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=f407211a&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=f407211a&prod&scoped=true&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=f407211a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f407211a",
  null
  
)

export default component.exports